import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'zh', 'de', 'fr', 'he', 'ar'],
    debug: process.env.NODE_ENV === 'development',
    
    detection: {
      order: ['cookie', 'localStorage', 'navigator'],
      lookupCookie: 'i18next',
      caches: ['cookie'],
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    backend: {
      loadPath: '/travel2/locales/{{lng}}.json?v=2',
    }
  });

export default i18n;
